module.exports = __webpack_public_path__ + "static/media/contact-list-correct.92946b84.png";